// Constants
export const DEBUG = false;
export const MOAT = 28;
export const CENTERED_ICON_TOP_MARGIN = 0.1;
